import React from 'react';

import './index.scss';

import iconUsuarios from '../../../../assets/images/icon_usuarios.svg';

export default (props) => {
  const {
    icon,
    label,
    count,
    countColor,
    renderData,
    customDataStyle,
    renderCustomDataStyle,
  } = props;

  const getCountDisplay = () => {
    return (
      <span
        className={`d-flex justify-content-center color-orange ${countColor}`}
      >
        {count || 0}
      </span>
    );
  };

  const renderCount = () => {
    const style =
      renderCustomDataStyle && customDataStyle ? customDataStyle : {};
    if (!renderData) {
      return (
        <div className="mt-3" style={style}>
          {getCountDisplay()}
        </div>
      );
    }
    return (
      <div className="count-render-elements mt-3" style={style}>
        {getCountDisplay()}
        {renderData()}
      </div>
    );
  };

  return (
    <div className="overview-card">
      <div className="d-flex justify-content-center">
        <img src={icon || iconUsuarios} alt="" />
      </div>
      <hr />
      <span className="d-flex justify-content-center mt-lg-5">
        {label || ''}
      </span>
      {renderCount()}
    </div>
  );
};
